import axiosInst from "api/config/axiosConfig";
import { showSuccess } from "utils/notifications";

export const resetSpeedwayPassword = async (eiSerialNumber: string) => {
  const response = await axiosInst.put(`/beta/eiStatusUIHook`, {
    eiSerialNumber,
    factoryResetPwd: true,
  });
  if (response.data.factoryResetPwd) {
    showSuccess("Password reset command sent successfully.");
  }
  return response.data;
};

export const factoryResetSpeedwayDevice = async (eiSerialNumber: string) => {
  const response = await axiosInst.put(`/beta/eiStatusUIHook`, {
    eiSerialNumber,
    factoryResetDevice: true,
  });
  if (response.data.factoryResetDevice) {
    showSuccess("Factory reset command sent successfully.");
  }
  return response.data;
};
